import { render, staticRenderFns } from "./DependentsInfo.vue?vue&type=template&id=11829c7e&"
import script from "./DependentsInfo.vue?vue&type=script&lang=js&"
export * from "./DependentsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports